<template>
  <div class="content-wrappper ">
    <div class="regulation-main">
      <div class="col-md-12 regulation-header regulationBackground">
        <div class="pb-24 d-flex space-between">
          <div class="d-flex" @click="navigateBack()">
            <img class="cursor-pointer" src="/static/images/icons/Headlines_Left_Chevron.svg" alt="download-icon" />
            <p class="m-0 regulation_check cursor-pointer">{{ $t('headlines') }}</p>
          </div>
          <div class="headline-button d-flex pt-0">
            <div class="delete d-flex">
              <button
                class="btn transparent-btn m-0 p-0 deselect-text btn-disabled deselect-button-color"
                :disabled="selectedHeadlines.length < 2"
                @click="setSelectedHeadlines('deselect')"
              >
                {{ $t('deselectAll') }}
              </button>
              <button class="btn transparent-btn btn-delete d-flex" :disabled="selectedHeadlines.length < 2" @click="openDeleteConfirmationPopup()">
                <img class="cursor-pointer delete-image mr-5" src="/static/images/icons/Headlines_Delete_icon.svg" alt="download-icon" />
                <span>{{ $t('delete') }}</span>
              </button>
            </div>
            <div class="pr-24 d-flex">
              <button type="button" class="btn emergo-btn emergo-primary-button" @click="openModal('add', {})" :disabled="headlinesList.length == 8">
                <img class="cursor-pointer mb-2 plus-icon" src="/static/images/icons/Add_plus.svg" alt="download-icon" /><span class="pl-8">{{
                  $t('addHeadline')
                }}</span>
              </button>
              <el-popover
                v-if="headlinesList.length == 8"
                class="cursor-pointer pl-8"
                placement="bottom-end"
                trigger="click"
                @show="infoActive = true"
                @hide="infoActive = false"
                width="350"
              >
                <div class="limit_popover_txt">
                  <span>
                    {{ $t('headlinesValidation') }}
                  </span>
                </div>
                <img class="info-icon" src="/static/images/icons/info_icon.svg" v-if="!infoActive" slot="reference" />
                <img class="info-icon" src="/static/images/icons/info_icon_active.svg" v-if="infoActive" slot="reference" />
              </el-popover>
            </div>
          </div>
        </div>

        <div class="col-xs-12 p-0 ">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
            <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-24">
              <div style="position:relative">
                <search-box v-model="searchValue" :searchCount="searchCount" @getList="filterHeadlinesList" :searchPlaceholder="$t('searchName')"></search-box>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 pl-25 pr-24 regulationBackground">
        <div class="">
          <table class="table table-responsive registration-data" id="regulationDataList">
            <tr style="background-color: #E6E6E6; !important;">
              <th class="" style="width:40px">
                <div class="checkbox cust_checkbox">
                  <input type="checkbox" class="form-control" v-model="isSelectAllHeadLines" @change="setSelectedHeadlines" />
                  <label></label>
                </div>
              </th>
              <th style="width: 80%">
                <div class="tableHeader cursor-pointer" @click="sortBy('title')">
                  <div class="ellipsis header-title" :title="$t('name')">{{ $t('name') }}</div>
                  <div class="arrow" :class="titleArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: auto">
                <div class="tableHeader cursor-pointer" @click="sortBy('date')">
                  <div class="ellipsis header-title" :title="$t('displayDate')">{{ $t('displayDate') }}</div>
                  <div class="arrow" :class="dateArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width:40px"></th>
            </tr>

            <tbody ref="tbodyBox" v-if="filteredHeadlines && filteredHeadlines.length">
              <tr :class="index % 2 === 0 ? 'table_data_part1' : 'table_data_part2'" v-for="(headline, index) in filteredHeadlines" :key="index">
                <td style="width:40px" class="checkbox-file">
                  <div class="checkbox cust_checkbox">
                    <input type="checkbox" class="form-control" :value="headline.id" v-model="selectedHeadlines" @change="setIsSelectAllHeadLines" />
                    <label></label>
                  </div>
                </td>
                <td style="width: 80%" class="ellipsis regulation-data">
                  <span :title="headline.product_name">{{ headline.title }}</span>
                </td>
                <td style="width: auto" class="ellipsis regulation-data regulation-date">
                  <span>{{ getDate(headline.display_date) }}</span>
                </td>
                <td style="width: 40px;">
                  <div class="dropdown dropdown-export custom-three-dots three-dots p-0 ">
                    <div data-toggle="dropdown" class="d-flex justify-content-end">
                      <span class="dropdown-toggle cursor-pointer" data-toggle="tooltip" data-placement="right">
                        <img class="info-img" src="/static/images/icons/headlines_3_vertical_dots_menu.svg" />
                      </span>
                    </div>
                    <ul class="dropdown-menu tooltip-pointer dropdown-menu-ul">
                      <li class="p-0 pl-0">
                        <a @click="openModal('edit', headline)">
                          <!-- <img src="/static/images/icons/Headlines_Edit_icon.svg" class="tracker-images" /> -->
                          <span class="MRL-4 edit-text">{{ $t('edit') }}</span>
                        </a>
                      </li>
                      <li class="p-0 pl-0">
                        <a @click="openDeleteConfirmationPopup(headline.id)">
                          <!-- <img src="/static/images/icons/Headlines_Delete_icon.svg" class="tracker-images" /> -->
                          <span class="MRL-4 delete-text">{{ $t('delete') }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <!-- <template>
                  <el-dropdown>
                      <span class="el-dropdown-link">
                          <img class="info-img" src="/static/images/icons/headlines_3_vertical_dots_menu.svg" />
                      </span>
                      <el-dropdown-menu class="edit-delete-tooltip">
                          <el-dropdown-item>
                              <div @click="openModal('edit', headline)" class="edit-delete-section">
                                  <img class="edit-delete-img" src="/static/images/icons/team_dropdown_edit.svg" />
                                  <div class="pl-24 edit">{{ $t('edit') }}</div>
                              </div>
                          </el-dropdown-item>
                          <el-dropdown-item>
                              <div @click="openDeleteConfirmationPopup(headline.id)" class="edit-delete-section">
                                  <img class="edit-delete-img del-btn" src="/static/images/icons/team_large_trashCan.svg" />
                                  <div class="pl-24 delete">{{ $t('delete') }}</div>
                              </div>
                          </el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
                </template> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="filteredHeadlines.length == 0 && !loaderStatus" class="no-records-found">
        {{ $t('headlinesEmptyStateMessage') }}
      </div>

      <add-edit-headline ref="headlinePopup" @getHeadlines="getHeadlines" :editDetails="editDetails" :type="type"></add-edit-headline>
      <delete-popup :deletewarnInfo="deleteWarningInfo" :deleteMember="true" @dashboardPublishDelete="deleteHeadline()" :headerTitle="headerTitle"> </delete-popup>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import $ from 'jquery';
import { Popover } from 'element-ui';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import AddEditHeadline from './AddEditHeadline.vue';
import DeletePopup from '../UIComponents/DeleteRegHeadlinePopup.vue';
import { getHeadlines, deleteHeadline } from '../../apis/headlines';
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      headLineSearch: '',
      isSelectAllHeadLines: false,
      allSelect: false,
      sortKey: '',
      checkedValue: false,
      deleteWarningInfo: {
        loaderStatus: false,
        title: this.$i18n.locale === 'Portuguese' ? 'Você está prestes a excluir a notícia' : 'You are about to delete headline'
      },
      loaderStatus: true,
      filteredHeadlines: [],
      editDetails: {},
      selectedHeadlines: [],
      type: '',
      titleArrowDirection: 1,
      dateArrowDirection: 1,
      isPreviouslySearched: false,
      searchValue: '',
      headlinesList: [],
      infoActive: false,
      searchCount: 0,
      headerTitle: ''
    };
  },
  components: {
    SearchBox,
    AddEditHeadline,
    DeletePopup,
    Loader,
    Popover
  },
  async created() {
    await this.getHeadlines();
    if (this.$route && this.$route.params) {
      if (this.$route.params.type === 'edit') {
        this.editDetails = this.$route.params.headline;
        this.type = 'edit';
        $('#HeadlinesModal').modal('show');
      }
    }
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },

  methods: {
    navigateBack() {
      this.$router.go(-1);
    },
    async getHeadlines() {
      this.loaderStatus = true;
      const response = await getHeadlines();
      // if (response.data.length) {
      this.headlinesList = response.data;
      this.filteredHeadlines = this.headlinesList;
      // }
      this.searchCount = this.filteredHeadlines.length;
      this.loaderStatus = false;
    },
    async filterHeadlines() {
      const searchStr = this.searchValue.trim();
      this.filteredHeadlines = [];
      if (!searchStr.length) {
        this.filteredHeadlines = this.headlinesList;
        this.searchCount = this.filteredHeadlines.length;
        return;
      }
      this.filteredHeadlines = this.headlinesList.filter((headline) => headline.title.toLowerCase().includes(this.searchValue.toLowerCase()));
      this.searchCount = this.filteredHeadlines.length;
    },
    validateCheckedValue() {
      const check = [];
      for (let i = 0; i <= this.checkedValue.length; i += 1) {
        if (this.validateFilterMemberVal(this.checkedValue[i])) {
          check.push(this.checkedValue[i]);
        }
      }
      this.checkedValue = check;
    },
    validateFilterMemberVal(id) {
      let valid = false;
      for (let member = 0; member < this.filterMembers.length; member += 1) {
        if (this.filterMembers[member].user_id === id) {
          valid = true;
          break;
        }
      }
      return valid;
    },
    filterHeadlinesList() {
      if (this.searchValue) {
        this.filterHeadlines();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterHeadlines();
        this.isPreviouslySearched = false;
      }
    },
    setSelectedHeadlines(type) {
      if (type === 'deselect') {
        this.isSelectAllHeadLines = false;
      }
      if (this.isSelectAllHeadLines) this.selectedHeadlines = this.filteredHeadlines.map((headline) => headline.id);
      else this.selectedHeadlines = [];
    },
    setIsSelectAllHeadLines() {
      this.isSelectAllHeadLines = this.selectedHeadlines.length === this.filteredHeadlines.length;
    },
    openModal(type, editDetails) {
      this.type = type;
      this.editDetails = editDetails;
      if (type === 'edit') {
        this.$refs.headlinePopup.selectedHeadLineDetails = this.editDetails;
        this.$refs.headlinePopup.setFormDetails();
      }
      $('#HeadlinesModal').modal('show');
    },

    openDeleteConfirmationPopup(id) {
      if (id) {
        this.deletionId = id;
        this.isSelectAllHeadLines = false;
        this.selectedHeadlines = [];
      }
      this.headerTitle = this.$i18n.locale === 'Portuguese' ? 'Excluir Notícia(s)' : 'Delete Headline(s)';
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async deleteHeadline() {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: true
      };
      let data = {};
      if (this.deletionId) {
        data = {
          id: [this.deletionId]
        };
        this.deletionId = '';
      } else {
        data = {
          id: this.selectedHeadlines
        };
      }
      const response = await deleteHeadline(data);
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: false
      };
      $('#modal_delete').modal('hide');
      if (response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Notícia excluída com sucesso' : 'Headline deleted successfully!',
          group: 'custom-notification'
        });
        this.checkedValue = [];
        await this.getHeadlines();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Não foi possível excluir o título' : "Headline couldn't be deleted",
          group: 'custom-notification'
        });
      }
      this.isSelectAllHeadLines = false;
      this.searchValue = '';
      this.selectedHeadlines = [];
      this.filterHeadlinesList();
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    getDate(date) {
      if (date === 'N/A') {
        return this.$i18n.locale === 'Portuguese' ? 'N/D' : date;
      }
      const formattedDate = this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
      return formattedDate;
    },

    sortBy(type) {
      if (type === 'title') {
        this.titleArrowDirection = -this.titleArrowDirection;
        if (this.titleArrowDirection === 1) this.filteredHeadlines.sort((a, b) => (a.title > b.title ? -1 : 1));
        else {
          this.filteredHeadlines.sort((a, b) => {
            const nameA = a.title.toUpperCase(); // ignore upper and lowercase
            const nameB = b.title.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          });
        }
      } else {
        this.dateArrowDirection = -this.dateArrowDirection;
        if (this.dateArrowDirection === 1) {
          this.filteredHeadlines.sort((a, b) => new Date(b.display_date) - new Date(a.display_date));
        } else {
          this.filteredHeadlines.sort((a, b) => new Date(a.display_date) - new Date(b.display_date));
        }
      }
    },
    getLanguage() {
      return this.$i18n.locale === 'Portuguese';
    }
  },
  mounted() {
    if (this.$route && this.$route.params) {
      if (this.$route.params.type === 'delete') {
        this.openDeleteConfirmationPopup(this.$route.params.headline);
      } else if (this.$route.params.type === 'add') {
        this.openModal('add', {});
      }
    }
  }
};
</script>

<style scoped>
.delete-text {
  font-size: 16px;
  color: #e12d33;
}
.info-icon {
  height: 18px;
  width: 18px;
  margin-top: 8px;
}
.plus-icon {
  height: 22px;
  width: 22px;
  margin-right: 8px;
  position: relative;
  bottom: 1px;
}
.mb-2 {
  margin-bottom: 2px;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mt-3 {
  margin-top: 3px;
}
.content-wrapper {
  width: calc(100% - 256px);
  margin-left: 256px;
}

.marketnews-main {
  /* margin-left: 230px; */
  padding: 24px;
}

.headline-title {
  font-size: 36px;
  line-height: 49px;
  color: #333333;
  padding-left: 22px;
}

.add_headline_button,
.add_headline_button:hover,
.add_headline_button:focus {
  border: none;
  background-color: #5a1dda;
  padding: 4px 14px 4px 15px;
  min-width: 172px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  border-radius: 5px;
  line-height: 25px;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
}
.header {
  justify-content: space-between;
  align-items: center;
}

.headline-button {
  display: flex;
  align-items: center;
}

.header-wrapper {
  margin-bottom: 25px;
}

.delete {
  justify-content: flex-end;
  align-items: center;
  column-gap: 18px;
}

.headlines-line {
  border-bottom: 1px solid rgba(11, 60, 97, 0.1);
}

.headline-count {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.search {
  margin-bottom: 18px;
}
.search-container >>> .search-icon > img {
  width: 32px;
  height: 32px;
}

.search-container {
  padding-left: 0px;
}
.count {
  margin-left: 17px;
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}

.deselect {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #34117e;
}

.created_date {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
}
.deselect-buttons {
  font-size: 18px;
  font-weight: 700;
}

.deselect-button-color,
.deselect-button-color:hover {
  color: #01518a;;
  /* background: #ffffff; */
  border: none;
}

.delete-button-color {
  padding-left: 20px;
  color: #b00505;
}

.btn-delete {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #b00505;
}
.delete-image {
  height: 18px;
  width: 18px;
}
.deselect-text {
  font-size: 14px;
  color: #01518a;
}
.tracker-images {
  height: 24px;
  width: 24px;
  margin-right: 16px;
}
.transparent-btn {
  border: none !important;
  background: transparent;
}
.pl-0 {
  padding-left: 0 !important;
  padding-bottom: 5px !important;
}
.btn-delete {
  color: #b00505 !important;
  padding: 0px 32px 0 20px;
  align-items: center;
}
.custom-three-dots {
  padding-right: 10px;
  padding-top: 5px;
}
.edit-text {
  font-size: 16px;
  color: #4d4d4d;
}
.tooltip-pointer li:first-child {
  padding-bottom: 18px;
}
.tooltip-pointer:before {
  position: absolute;
  top: -12px;
  height: 0;
  width: 0;
  /* left: 84%; */
  right: 4%;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 12px solid #ffffff;
  content: '';
}
.dropdown-menu-ul {
  /* left: -150px !important; */
  right: 7px !important;
  left: unset;
}
.dropdown-menu-ul::after {
  right: 1em !important;
}
.dropdown-menu {
  /* left: -15px; */
  min-width: 193px;
  height: 70px;
  filter: drop-shadow(0px 0px 10px #b2b2b2);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  border: none;
  top: 42px !important;
  padding: 0px 0px 0px 20px;
  background: #ffffff;
}
.dropdown-menu > li > a {
  padding: 0px;
  display: flex;
  color: rgb(52, 17, 126);
}
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover {
  color: rgb(52, 17, 126);
}
.dropdown-menu .divider {
  margin: 0px;
}
.dropdown-export .export-menu li .MRL-4 {
  margin-left: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #34117e;
}
.dropdown-export .export-menu li .MRR-4 {
  margin-right: 4px;
}
.dropdown-export .export-menu img,
.viewRegistration img {
  width: 18px;
  vertical-align: sub;
  height: 18px;
}
.dropdown-export .export-menu img.unarchive {
  height: 20px;
}
.dropdown-export .export-menu span {
  font-size: 14px;
}
.add_headline_button,
.add_headline_button:hover {
  background-color: #01518a;
  border-radius: 3px;
  padding: 4px 16px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin-right: 5px;
}
.space-between {
  justify-content: space-between;
}
.checkbox {
  position: relative;
}

input[type='checkbox'] {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  width: 18px !important;
  height: 18px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}

.checkbox label:before {
  content: '';
  width: 18px !important;
  height: 18px !important;
  border: 2px solid #4d4d4d;
  display: inline-block;
  position: absolute;
  left: 0;
  top: -2px;
  border-radius: 3px;
}
.checkbox-file {
  /*
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E; */
  padding: 14px 0px 0px 0px !important;
}

.checkbox.cust_checkbox input[type='checkbox']:disabled + label:before {
  /* border: 1px solid #828282; */
  /* opacity: 0.5; */
}

.checkbox input[type='checkbox']:checked + label:before {
  background-color: #01518a;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 12px 15px;
  background-repeat: no-repeat;
  background-position-x: center;
  border: none;
}
/* .tbody.checkbox label{
  top: 7px !important;
} */
.checkbox label {
  cursor: auto;
  top: 5px;
  position: relative;
}

.cust_checkbox {
  /* margin: 0px; */
  margin: 0px 13px 0px 15px;
  display: inline-block;
}
.checkbox-file {
  padding: 14px 0px 0px 0px !important;
}
.footer {
  text-align: right;
  padding-right: 25px;
  padding-bottom: 20px;
  background-color: #e5e5e5 !important;
}
.ul_finish_button,
.ul_finish_button:hover {
  background-color: #01518a;
  /* border-radius: 3px; */
  /* border: 1px solid #5a1dda; */
  height: 34px;
  width: 123px;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 25%); */
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
.regulation-header {
  padding: 24px 0px 0px 25px;
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518a;
  /* padding-bottom: 4px; */
}
.table_data_part1 {
  background-color: #fafafa;
}
.table_data_part2 {
  background-color: #f5f5f5;
}
.pb-24 {
  padding-bottom: 24px;
}
.pb-14 {
  padding-bottom: 14px;
}
.header-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333;
  padding: 14px 0px 16px 12px !important;
}
.regulation-date {
  color: #3e3e3e;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.regulation-main {
  background-color: #e5e5e5 !important;
  height: calc(100vh - 50px) !important;
}
.regulation_check {
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  color: #3e3e3e;
  padding-left: 16px;
  display: flex;
  align-items: center;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding: 14px 0px 12px 12px;
  column-gap: 7px;
  /* justify-content: center; */
}
.regulationBackground {
  background-color: #e5e5e5;
}
#regulationDataList th .arrow {
  opacity: 1;
}
#regulationDataList thead,
#regulationDataList tbody,
#regulationDataList tr:not(#regulationDataList thead tr) {
  display: table;
  width: 100%;
  table-layout: fixed;
}
</style>
